var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history"},[_c('el-dialog',{attrs:{"title":"高线厂/AB高线/驱动端水平","visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div'),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }